import Cookies from 'js-cookie';
import authService from '../services/authService';

// Check if user is logged in; if access token missing but refresh exists, attempt silent refresh once per load.
export const isAuthenticated = () => {
    const token = Cookies.get('token');
    const refreshToken = Cookies.get('refreshToken');
    const userId = Cookies.get('userId');
    if (!userId) {
        console.log('🔍 Auth check: no userId -> not authenticated');
        return false;
    }
    if (token) {
        console.log('🔍 Auth check: token present -> authenticated');
        return true;
    }
    if (refreshToken && !window.__silentRefreshAttempted) {
        window.__silentRefreshAttempted = true;
        console.log('🔄 Auth check: attempting silent refresh...');
        authService.refreshToken()
            .catch((err) => {
                // Log the error for debugging; silent refresh failures are not shown to the user.
                console.error('🔴 Silent refresh failed:', err);
            })
            .finally(() => {});
    }
    return false;
};

// Logout function that clears all authentication cookies
export const logout = () => {
    console.log("🔒 Logging out. Clearing cookies...");
    // Clear all authentication-related cookies
    Cookies.remove('token');
    Cookies.remove('refreshToken');
    Cookies.remove('userId');
    Cookies.remove('isAdmin'); // Clear admin status cookie
    console.log("✅ Cookies cleared. Redirecting to login page.");
    
    // Optionally force reload to clear any in-memory state
    window.location.href = '/';
};
